import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/producciones';
import ProduccionCrear from './ProduccionCrear';

const mstp = state => {
    return {...state.producciones}
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(ProduccionCrear)
